import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { setLang, storedLang } from './i18n';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('console-ng');

  constructor() {
    // 启动时应用持久化语言（无则默认 en）。
    const translate = inject(TranslateService);
    setLang(translate, storedLang());
  }
}
